import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import HOMEBANNER from '../images/FRIDGEBANNER.jpg'
import WASHINGMACHINE from '../images/REF.png'
import { FaQuestionCircle } from "react-icons/fa";
import CountUp from 'react-countup';
import { FaSmile, FaMapMarkedAlt, FaThumbsUp } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Home.css'
import AOS from 'aos';
import { FaCalendarAlt, FaClock, FaHeadset } from 'react-icons/fa';
// import 'aos/dist/aos.css';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";
import WASHWORK1 from '../images/fridge.jpg';

import FL1 from "../images/FL1.png";
import FL2 from "../images/FL2.jpeg";
import FL3 from "../images/FL3.jpg";
import FL4 from "../images/FL4.jpg";
import FL5 from "../images/FL5.png";
import FL6 from "../images/FL6.jpg";
import { FaPhoneAlt } from 'react-icons/fa';








export default function FridgeService() {





  const faqs = [
    {
      question: "What makes your fridge service low-cost?",
      answer: "Our fridge service is cost-effective due to our efficient workflows and minimal overhead costs. We ensure quality service without overcharging."
    },
    {
      question: "What is your policy on repeat fridge issues?",
      answer: "If the same fridge issue occurs again within one month, we provide a free follow-up service to fix the problem."
    },
    {
      question: "Do you provide a warranty on fridge spare parts?",
      answer: "Yes, we offer a 3 to 6-month warranty on all fridge spare parts, depending on the brand and part type."
    },
    {
      question: "Can I see the fridge spare parts before installation?",
      answer: "Yes, we show all replacement parts to customers before installation to ensure transparency and trust."
    },
    {
      question: "How can I schedule a fridge service?",
      answer: "You can contact us anytime — we are available 24/7 to schedule a service visit at your convenience."
    },
    {
      question: "What types of fridge problems do you handle?",
      answer: "We handle cooling issues, gas filling, compressor faults, thermostat issues, water leaks, door seal problems, and more."
    },
    {
      question: "Are your technicians experienced in fridge repair?",
      answer: "Yes, our technicians are highly experienced and trained to service all refrigerator types and brands."
    },
    {
      question: "Do you offer emergency fridge repair services?",
      answer: "Yes, we provide urgent repair services for fridges, especially when cooling failure or food spoilage is a concern."
    },
    {
      question: "How can I keep my fridge running efficiently?",
      answer: "Keep the coils clean, avoid overloading, and call for regular servicing. Our experts also share maintenance tips during visits."
    },
    {
      question: "What if I have more questions about fridge service?",
      answer: "Feel free to contact us anytime. Our customer support team is ready to assist with all your fridge-related concerns."
    }
  ];
  const tips = [
    {
      title: "Clean the Condenser Coils",
      content: "Dust and dirt on the coils can reduce cooling efficiency. Clean them every 6 months to ensure optimal performance."
    },
    {
      title: "Check the Door Seal",
      content: "Make sure the rubber door gasket is clean and sealing tightly. A loose seal lets cold air escape, increasing energy usage."
    },
    {
      title: "Set the Right Temperature",
      content: "Keep the fridge at or below 4°C (40°F) and the freezer at -18°C (0°F) for food safety and energy efficiency."
    },
    {
      title: "Avoid Overloading the Fridge",
      content: "Too many items block airflow and make the compressor work harder. Leave some space for air to circulate."
    },
    {
      title: "Don’t Block Air Vents",
      content: "Ensure food items don’t obstruct the internal vents, allowing consistent cooling throughout the fridge."
    },
    {
      title: "Keep It Away from Heat Sources",
      content: "Avoid placing the fridge near stoves, ovens, or direct sunlight, which can force it to work harder to stay cool."
    },
    {
      title: "Store Food Properly",
      content: "Cover food and store it in containers to reduce moisture and odors that strain the fridge's cooling system."
    },
    {
      title: "Defrost Regularly (if needed)",
      content: "If your fridge is not frost-free, defrost it manually when ice buildup gets too thick to maintain efficiency."
    },
    {
      title: "Inspect for Leaks or Unusual Sounds",
      content: "Strange noises or water leaks could signal a problem. Investigate early to avoid bigger issues later."
    },
    {
      title: "Call a Technician for Cooling Issues",
      content: "If the fridge isn't cooling properly or has electrical problems, contact a professional to check components like the thermostat or compressor."
    }
  ];




  const accordionData = [
    {
      title: "Fridge Repair Services",
      content: "We handle all types of refrigerator problems including cooling issues, unusual noises, and electrical faults with expert care."
    },
    {
      title: "Fridge Maintenance",
      content: "Regular maintenance ensures your fridge operates efficiently, saves energy, and extends its lifespan."
    },
    {
      title: "Fridge Installation",
      content: "We offer reliable and safe installation services for all types of refrigerators, including single-door, double-door, and side-by-side models."
    },
    {
      title: "Fridge Troubleshooting",
      content: "Quick and accurate diagnosis of performance issues like water leakage, defrost failure, or inconsistent cooling."
    },
    {
      title: "Fridge Parts Replacement",
      content: "We replace faulty components such as thermostats, compressors, timers, and sensors using genuine, high-quality parts."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const toggleTip = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const services = [
    { title: "Refrigerator Repairing", desc: "Quick Diagnosis", img: FL1 },
    { title: "Refrigerator Maintenance", desc: "High-Quality Clean", img: FL2 },
    { title: "Refrigerator Installation", desc: "Preventive Maintenance", img: FL3 },
    { title: "Refrigerator Service", desc: "Gas Chekup", img: FL4 },
    { title: "Refrigerator Service", desc: "General Maintenance", img: FL5 },
    { title: "Refrigerator Service", desc: "Motor Repair", img: FL6 },

  ];



  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    appliance: '',
    issue: ''
  });

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { name, phone, city, appliance, issue } = formData;
    const message = `New Complaint:%0AName: ${name}%0APhone: ${phone}%0ACity: ${city}%0AAppliance: ${appliance}%0AIssue: ${issue}`;
    const whatsappURL = `https://wa.me/919342851992?text=${message}`; // Replace with your number
    window.open(whatsappURL, '_blank');
  };










  return (
    <>
      <Navbar />

      <section id="Banner-home" className="banner-home" style={{ backgroundImage: `url(${HOMEBANNER})` }}>
        <div className="banner-overlay">
          <div className="banner-container">
            {/* Left Side */}
            <div className="banner-left glass-effect">
              <h1 className="headline">Refrigerator Service Center</h1>
              <a href="tel:+919342851992" className="call-btn">
                <FaPhoneAlt style={{ marginRight: '8px' }} />
                +919342851992
              </a>
            </div>

            {/* Right Side - Contact Form */}
            <div className="banner-right">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                <input type="text" name="city" placeholder="City" required onChange={handleChange} />
                <select name="appliance" required onChange={handleChange}>
                  <option value="">Select Appliance</option>
                  <option value="Washing Machine">Washing Machine</option>
                  <option value="Refrigerator">Refrigerator</option>
                  <option value="AC">AC</option>
                  <option value="TV">TV</option>
                </select>
                <textarea name="issue" placeholder="Tell us your issue..." required onChange={handleChange}></textarea>
                <button type="submit" className="submit-btn">Submit & Send to WhatsApp</button>
              </form>
            </div>
          </div>
        </div>
      </section>




      <section id="home-about">
        <div className="about-container">
          {/* Left Side */}
          <div className="about-left" data-aos="fade-left">
            <h2>About Our Company</h2>
            <h3>Home Appliance Assist</h3>
            <p>
              If your refrigerator stops cooling or shows signs of trouble, don’t worry. Contact us, and we’ll resolve the issue promptly and professionally. We provide convenient, on-site fridge repair services — just schedule a service call, and our technicians will come to your location. Or, visit us directly, and our skilled experts will fix the issue efficiently. We offer reliable and expert refrigerator services for all types and brands, including single-door, double-door, and side-by-side models. With over <strong>8+ years</strong> of experience in the appliance service industry, Home Appliance Assist is dedicated to providing high-quality service and complete customer satisfaction.
            </p>



            <img src={WASHINGMACHINE} alt='washing machine service' title='washing machine repair' className='img-fluid' />
          </div>

          {/* Right Side Boxes */}
          <div className="about-right">
            <h3>Issue In Refrigerator</h3>
            <div className="service-box" data-aos="fade-right" data-aos-delay="100">
              <p>Fridge Not Cooling Properly</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="200">
              <p>Water Leakage Inside Fridge</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="300">
              <p>Excessive Ice Build-Up in Freezer</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="400">
              <p>Fridge Not Turning On</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="500">
              <p>Unusual Noise from Fridge</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="600">
              <p>Bad Odor Inside Fridge</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="700">
              <p>Compressor Not Functioning</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="800">
              <p>Door Seal or Gasket Issues</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="900">
              <p>Fridge Light Not Working</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="1000">
              <p>Fridge Needs Regular Servicing</p>
            </div>



          </div>
        </div>
      </section>



      <section id="washing-machine-service" className="washing-service-section">
        <h2 className="section-title">What We Do for Fridge Service</h2>
        <div className="washing-service-grid">
          {services.map((service, index) => (
            <motion.div
              className="washing-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img src={service.img} alt={service.title} className="washing-img" />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="washing-accordion-section" className="accordion-wrapper">
        <div className="accordion-container">
          <div className="accordion-image">
            <img src={WASHWORK1} alt="Washing Machine Service" />
          </div>
          <div className="accordion-content">
            <h2>Refrigerator Service Details</h2>
            {accordionData.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div
                  className={`accordion-title ${activeIndex === index ? "active" : ""}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <h3>{item.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div
                  className={`accordion-body ${activeIndex === index ? "open" : ""}`}
                >
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/*    
     <section id="desc" className="service-section">
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>Washing Machine Issues?</h2>
           <p>
             Is your washing machine making noise, not spinning, or leaking water? Don’t worry — our trained experts diagnose and fix all issues quickly. 
             We offer <strong>same-day doorstep service</strong> to get your appliance back up and running smoothly.
           </p>
           <a href="/washing-machine-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={WASHINGMACHINE} alt="Washing Machine Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>AC Not Cooling?</h2>
           <p>
             Whether it's low cooling, water leakage, or unusual noise, our technicians provide <strong>same-day AC repair</strong> with expert diagnostics and professional care.
           </p>
           <a href="/ac-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={AC} alt="AC Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>Fridge Not Working?</h2>
           <p>
             Experiencing cooling issues or strange noises? Let our experienced technicians help. We offer <strong>quick same-day service</strong> for all fridge problems.
           </p>
           <a href="/fridge-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={REF} alt="Fridge Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>TV Not Turning On?</h2>
           <p>
             From screen issues to sound problems, we repair all types of TVs — LED, LCD, Smart TVs and more. Our <strong>same-day service</strong> ensures quick solutions.
           </p>
           <a href="/tv-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={TV} alt="TV Service" />
         </div>
       </div>
     </section>
     
     
  
     
      */}



      <section id="washing-tips-section" className="tips-wrapper">
        <div className="tips-container">
          <h2>Refrigerator Tips and Tricks</h2>
          <div className="tips-accordion">
            {tips.map((tip, index) => (
              <div className="tip-item" key={index}>
                <div className="tip-header" onClick={() => toggleTip(index)}>
                  <h3>{index + 1}. {tip.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div className={`tip-body ${activeIndex === index ? "open" : ""}`}>
                  <p>{tip.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section id="why-us" className="why-us-section">
        <div className="why-us-heading" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="why-us-grid">
          <div className="why-us-card" data-aos="fade-right">
            <h3>Expert Technicians</h3>
            <p>Our team consists of certified experts with years of experience in appliance repairing and maintenance.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Quick Service</h3>
            <p>We value your time and offer prompt service, ensuring your appliances are up and running in no time.</p>
          </div>
          <div className="why-us-card" data-aos="fade-right">
            <h3>Quality Assurance</h3>
            <p>We use genuine parts and provide a guarantee on our work, so you can trust in the quality of our service.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Affordable Pricing</h3>
            <p>Our pricing is transparent and competitive, ensuring you get the best value for your money.</p>
          </div>
        </div>
      </section>

      <section id="impact" className="impact-section" ref={ref}>
        <h2 className="impact-heading" data-aos="fade-up">Our Impact in Numbers</h2>
        <div className="impact-container">
          <div className="impact-card" data-aos="fade-up" data-aos-delay="100">
            <FaSmile className="impact-icon" />
            <h2>{inView && <CountUp end={50000} duration={2} />}+</h2>
            <p>Happy Customers</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="200">
            <FaMapMarkedAlt className="impact-icon" />
            <h2>{inView && <CountUp end={60} duration={2} />}+</h2>
            <p>Areas Covered</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="300">
            <FaThumbsUp className="impact-icon" />
            <h2>{inView && <CountUp end={49000} duration={2} />}+</h2>
            <p>Satisfied Customers</p>
          </div>
        </div>
      </section>
      <section id="washing-faq-section" className="faq-section">
        <div className="faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div className="faq-card" key={index}>
                <div className="faq-icon">
                  <FaQuestionCircle />
                </div>
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="availability" className="availability-section">
        <h2 className="availability-heading" data-aos="fade-up">Our Availability</h2>
        <div className="availability-grid">
          <div className="availability-card" data-aos="fade-right">
            <FaCalendarAlt className="availability-icon" />
            <h3>Opening Day</h3>
            <p>
              Monday to Saturday <br />
              <span className="sunday-text">Sunday - Closed</span>
            </p>
          </div>
          <div className="availability-card" data-aos="fade-up">
            <FaClock className="availability-icon" />
            <h3>Office Available</h3>
            <p>9:00 AM to 9:00 PM</p>
          </div>
          <div className="availability-card" data-aos="fade-left">
            <FaHeadset className="availability-icon" />
            <h3>Customer Support</h3>
            <p>24/7 Available</p>
          </div>
        </div>
      </section>


      <section id="disclaimer" className="disclaimer-section" data-aos="fade-up">
        <div className="disclaimer-container">
          <div className="disclaimer-icon">
            <FaExclamationTriangle />
          </div>
          <div className="disclaimer-content">
            <h2>Disclaimer</h2>
            <p>
              Home Appliance Assist is an independent service provider offering expert repairing and maintenance services for a wide range of home appliances. We specialize in servicing all major home appliance types, including refrigerators, washing machines, air conditioners, and televisions.
            </p>
            <p>
              Please note that Home Appliance Assist is not affiliated with, endorsed by, or associated with any specific appliance manufacturers or brands. We do not use any brand names, trademarks, or logos on our website or in our promotional materials. All services provided are carried out by our team of experienced and certified technicians, independent of any manufacturer's certification.
            </p>
            <p>
              While we provide high-quality service for various appliance types, our services are not authorized by or affiliated with the manufacturers of the products we repair. Customers seeking manufacturer-authorized service and genuine parts should contact the official customer support of the respective brands.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>

  )
}
